// El SLA de un ticket está en pausa cuando tiene marca de pausa (fechaEsperandoUsuario). La pone el estado «Esperando Usuario»
// o, a mano, soporte (ticket que espera a un tercero y sigue «En Proceso»). Esta última es la «pausa manual».
const CERRADOS = ['Resuelto', 'Cerrado', 'Cancelado'];

export const slaEnPausa = (t) => !!(t && t.fechaEsperandoUsuario);

/** Pausa puesta a mano por soporte: con marca de pausa, pero en un estado que no es «Esperando Usuario». */
export const slaPausadoManual = (t) => slaEnPausa(t) && t.estado !== 'Esperando Usuario' && !CERRADOS.includes(t.estado);

/** ¿Se puede pausar a mano? Abierto, sin pausa y sin estar esperando al usuario (ahí el SLA ya está detenido). */
export const puedePausarSla = (t) => !!t && !CERRADOS.includes(t.estado) && t.estado !== 'Esperando Usuario' && !slaEnPausa(t);

export const MOTIVOS_PAUSA = ['Esperando a un proveedor', 'Esperando desarrollo / integración', 'Esperando a otra área', 'Esperando una compra o repuesto'];
